<template>
  <div>
    <div
      v-if="locationNotRecognised"
      class="Notice Notice--warning"
    >
      <p class="Notice-copy">
        Sorry, we didn't understand the location <strong>{{ query.location }}</strong>
      </p>
    </div>
    <div
      v-else-if="alternativeLocations && alternativeLocations.length"
      class="Notice Notice--warning"
    >
      <p class="Notice-copy">
        Sorry, we didn't understand the location <strong>{{ query.location }}</strong>
      </p>
      <p class="Notice-copy">
        Showing results for <strong>{{ currentLocation.formatted_address }}</strong>
      </p>

      <p class="Notice-copy">
        Or choose from:
      </p>

      <select
        @change="updateQueryFilters"
      >
        <option
          :value="false"
        >
          - select -
        </option>
        <option
          v-for="alternativeLocation in alternativeLocations"
          :key="alternativeLocation.formatted_address"
          :value="alternativeLocation.formatted_address"
        >
          {{ alternativeLocation.formatted_address }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import useLocationPrettyUrl from '@/composables/use-location-pretty-url';

const {
  addLocationToUrl,
  removeLocationFromUrl,
} = useLocationPrettyUrl();

export default {
  data() {
    return {
      ui: {},
    };
  },

  computed: {
    ...mapState('search', {
      query: (state) => state.query,
      locations: (state) => state.locationsMeta.locations,
      alternativeLocations: (state) => state.locationsMeta.alternative_locations,
      locationNotRecognised: (state) => state.locationsMeta.locationNotRecognised,

      currentLocation() {
        return this.locations[0];
      },
    }),
  },

  methods: {
    ...mapMutations('search', {
      storeUpdateQueryFilters: 'updateQueryFilters',
      updateSearchUrl: 'updateSearchUrl',
    }),

    updateQueryFilters(event) {
      if (event.currentTarget.value === 'false') {
        return false;
      }

      const {
        pathname,
        search,
      } = addLocationToUrl({name: event.currentTarget.value, slug: null});

      this.updateSearchUrl(`${pathname}${search}`);

      return this.storeUpdateQueryFilters({
        filterValues: event.currentTarget.value,
        filterName: 'location',
      });
    },
  },
};
</script>

<style scoped>
  .Notice-copy {
    display: block;
    margin-bottom: 0.5rem!important;
  }
</style>
